import React, {useEffect} from 'react';
import Inicio from './paginas/Inicio'

const App = () => {

  return (
    <Inicio />
  );
}

export default App;